var _path, _path2, _radialGradient;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    fill: "none",
    viewBox: "0 0 41 41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_radial_3188_87365)",
    d: "M0.425293 13.4865C0.425293 6.314 6.23978 0.499512 13.4123 0.499512H27.4383C34.6108 0.499512 40.4253 6.314 40.4253 13.4865V27.5125C40.4253 34.685 34.6108 40.4995 27.4383 40.4995H13.4123C6.23978 40.4995 0.425293 34.685 0.425293 27.5125V13.4865Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "evenodd",
    d: "M16.4116 9.52284C22.3695 6.78239 26.8028 6.49245 29.5714 8.82136C34.4724 12.9554 32.4053 18.773 30.5067 23.8985C28.9728 27.9764 27.3734 30.4737 25.7834 31.9889C23.1832 34.4955 21.1162 34.6077 19.5262 34.4955C16.1684 34.3271 13.456 32.4659 10.4444 28.1541C7.85356 24.4877 5.73042 20.5875 7.67586 16.2196C7.97515 15.5181 9.20976 12.8432 16.4116 9.52284ZM24.9209 22.3746C22.6316 28.7491 20.9813 28.6054 19.6934 28.4932L19.6738 28.4915C18.4392 28.3793 16.9053 27.154 15.1937 24.7035C12.7151 21.0932 12.8367 20.0457 13.426 18.6521C13.8375 17.6607 15.3153 16.6693 18.9723 14.9296C23.1064 12.9467 24.8086 13.3022 25.4633 13.7698C26.9879 14.9202 26.9879 16.6038 24.9209 22.3746Z",
    clipRule: "evenodd"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3188_87365",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(21.3084 20.4586) scale(39.452 36.6346)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177083,
    stopColor: "#1DF4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#17E23B"
  }))));
};
export default SvgLogo;